module.exports = __webpack_public_path__ + "static/media/icon-other.fb845535.svg";